// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2p-3";
export var dialog = "_2p-0";
export var divClassnameSwatch = "_2p-8";
export var flexSwatch = "_2p-4";
export var header = "_2p-1";
export var styleAttributeSwatch = "_2p-7";
export var swatch = "_2p-2";
export var textHeaderSwatch = "_2p-5";
export var webSwatch = "_2p-6";